module.exports = __webpack_public_path__ + "img/stop-17.674a569a.jpg";